<template>
  <div class="performance_box prof" v-if="userDetails.gamesPlayed > 0">

    <h1>{{ getTranslations.home_profile_profile_performance }}</h1>

    <div id="accordion">

      <div v-for="index in totalLoops"  :key="index.type" >
        <!-- ALL GAMES -->
        <div class="performance_bg">

          <div class="accordion_top" role="button">
            <div class="performance_row_title">
              <h2>{{updateText(index)}}</h2>
            </div>
            <div class="performance_row_text">
              <p><span>{{ performanceInfo[index - 1].accuracy  }}% </span>{{ getTranslations.home_profile_profile_accuracy }}</p>
              <p><span>{ {{ performanceInfo[index-1].gameWon }}/{{ performanceInfo[index-1].gamePlayed }}   {{ getTranslations.home_profile_profile_correct }} )</span></p>
            </div>
            <div class="progressbar">
              <div :class="['progressbar__bar',performanceInfo[index -1].name]" :data-percent='performanceInfo[index - 1].accuracy'></div>
            </div>

          </div>

          <div class="slide">

            <div class="desktop_perf_block">

                <performance-circle :performance='putData(index)' :circles="3"/>

            </div>

            <div class="mobile_perf_carousel">
              <div class="swiper">
                <div class="swiper-wrapper">


                  <performance-circle :performance='putData(index)'
                  :circles="3" :mobile="true"/>

                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="perf_horizontal_line" ></div>

        <!-- EASY GAMES -->
      </div>


    </div>
  </div>
  <div class="performance_box prof empty" v-else>
    <h1>{{ getTranslations.home_profile_profile_your_performance }}</h1>
    <img src="/static/images/profile/profile-emptystate.png">
    <p>{{ getTranslations.home_profile_profile_empty }}</p>
  </div>

</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex';
import 'owl.carousel';
import { profileFullBar } from '@/common/jQuery';
import $ from 'jquery';
import PerformanceCircle from './PerformanceCircle';


export default {
  name: 'profile-performance',
  components: { PerformanceCircle },
  data() {
    return {
      dataWon: [0, 0, 0, 0],
      dataPlayed: [0, 0, 0, 0],
      respon: {},
      showStatus: [true, true, true, true],
      themeText: null,
      text: ['', '', '', ''],
      title: '',
      checkButton: 4,
      totalLoops: null,
      titleText: ['', '', '', ''],
      performannceStatus: [0.0, 0.0, 0.0, 0.0],
      index: 0,
      j: 4,
      bestPerformance: [''],
      display: false,
    };
  },
  mounted() {
    /* eslint-disable */
    profileFullBar();

    $('.owl-carousel').owlCarousel({
      loop: false,
      responsiveClass: true,
      autoplay: false,
      autoplayHoverPause: true,
      navContainer: '.carousel__nav',
      responsive: {
        321: {
          // centeredSlides: true,
          items: '2',
          nav: 0,
        },
        0: {
          items: '2',
          nav: 0,
        },

      }
    });

    $(".progressbar__bar").each(function (t, e) {
      var n = $(e).data("percent");
      $(e).width(n + "%")
    })
    $('.slide').hide();

    $("#accordion").find("div[role|='button']").click(function() {

      $("#accordion").find("div[role|='button']").removeClass('active');
      $('.slide').slideUp('fast');
      var selected = $(this).next('.slide');
      $(".accordion_top").parent().removeClass('selected')

      if (selected.is(":hidden")) {
        $(this).next('.slide').slideDown('fast');
        $(this).toggleClass('active');
        $(this).parent().addClass('selected').siblings().removeClass('selected');
      } else {
        $(this).parent().removeClass('selected');
      }

    });
  },
  created() {
    console.log(this.performanceInfo[0]);
    if (this.userDetails.gamesPlayed > 0) {
      this.performanceInfo[0].pointsEarned = this.userDetails.totalPointsEarned;
      this.performanceInfo[0].gamesUnlocked = this.userDetails.gamesPlayed;
    }
    if (this.swipoGameThemes === 'MIXED') {
      this.totalLoops = 1;
    }
    else {
      this.totalLoops =this.performanceInfo.length;
    }
    console.log('Load Profile');
    this.text[0] = this.getTranslations['home_profile_profile_all'];
    this.text[1] = this.getTranslations['home_profile_profile_easy'];
    this.text[2] = this.getTranslations['home_profile_profile_hard'];
    this.text[3] = this.getTranslations['home_profile_profile_very_hard'];
    this.titleText[0] = this.getTranslations['home_profile_profile_logic'];
    this.titleText[1] = this.getTranslations['home_profile_profile_memory'];
    this.titleText[2] = this.getTranslations['home_profile_profile_attention'];
    this.titleText[3] = this.getTranslations['home_profile_profile_rounder'];
  },
  methods: {
    ...mapActions('profile', [
      'storePerformance',
    ]),
    updateText(index) {
      return this.getTranslations[`home_profile_profile_${this.performanceInfo[index-1].name}`];
    },
    checkSum(index,data){
      let max = 0;
      max = Math.max(...data);
      let sum = 0;
      let position = -1;
      for (let i = 0; i < data.length; i++) {
        sum += data[i];
        if ( data[i] == max) {
          position = i;
        }
      }
      let value = 0;
      if( sum === 0 )
        this.showStatus[index-1] = false;
      else {
        this.bestPerformance[0] = this.titleText[position];
      }
    },
    putData(index) {
      const data = [0, 0, 0, 0];
      data[0] = this.performanceInfo[index-1].gamePlayed;
      data[1] = this.performanceInfo[index-1].pointsEarned;
      data[2] = this.performanceInfo[index-1].gamesUnlocked;
      return data;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'swipoGameThemes',
    ]),
    ...mapState('profile', [
      'performanceInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};

</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfilePerformance.vue